import * as Diagram from "../../../../components/diagram";

export const CaseScaleTotalScore = {
  label: "個案量表總分",
  key: "CaseScaleTotalScore",
  path: "ElderlyHealth/CaseScaleTotalScore",
  api: "TCS_V_OHCheckItems01V",
  render: (options) => (
    <Diagram.ElderlyHealth.CaseScaleTotalScore {...options} />
  ),
  isRaw: true,
  isPage: true,
  page: null,
  filterColumns: [{ key: "篩檢年份", type: "string" }],
  columns: [
    {
      key: "PID",
      field: "PID",
      header: "身分證",
    },
    {
      key: "Name",
      field: "Name",
      header: "個案姓名",
    },
    {
      key: "RegionName",
      field: "RegionName",
      header: "鄉別",
    },
    {
      key: "Address",
      field: "Address",
      header: "地址",
    },
    {
      key: "Phone",
      field: "Phone",
      header: "電話",
    },
    {
      key: "IsDead",
      field: "IsDead",
      header: "死亡",
    },
    {
      key: "篩檢年份",
      field: "篩檢年份",
      header: "篩檢年份",
    },
    {
      key: "CaseID",
      field: "CaseID",
      header: "案件編號",
    },
    {
      key: "訪視類別",
      field: "訪視類別",
      header: "訪視類別",
    },
    {
      key: "ADL",
      field: "ADL",
      header: "ADL",
    },
    {
      key: "IADL_count",
      field: "IADL_count",
      header: "IADL需協助項次數",
    },
    {
      key: "SOF",
      field: "SOF",
      header: "SOF",
    },
    {
      key: "AD8",
      field: "AD8",
      header: "AD8",
    },
  ],
};
